import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames/bind'
import cls from './styles.scss'
import { Icon, Label } from '@adc/ui-core'
const cx = classNames.bind(cls)

/**
 * This renders the category layout for the autosuggest component.
 * We are leveraging the global class 'results' (semantic-ui) to add a number of the styles e.g. highlighting
 * selected suggestion, however this requires a few overrides in css to make it work.
 */
export const CategoryLayout = ({ categoryContent, resultsContent }) => (
  <div className={cx('category-container')}>
    <div className={cx('category-label')}>{categoryContent}</div>
    <div className={cx('results', 'results-wrapper')}>{resultsContent}</div>
  </div>
)

CategoryLayout.propTypes = {
  categoryContent: PropTypes.node,
  resultsContent: PropTypes.node,
}

export const Category = ({ name, icon }) => (
  <div className={cx('category-label-row')}>
    <div className={cx('autosuggest-icon-container')}>
      {!_.isEmpty(icon) && (
        <Icon
          name={icon.name}
          iconStyle='regular'
          color={icon.color || 'grayMedium'}
        />
      )}
    </div>
    <Label className='category' as='span' content={name} />
  </div>
)

Category.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
  }),
}

/**
 * This is the new suggestion renderer with a refreshed UI for the new blueprint integration.
 * It handles all the different suggestion types and renders them accordingly.
 * TODO: remove all the old renderers and use this one instead.
 */

export const Suggestion = ({
  elmId,
  index,
  icon = {},
  label,
  subLabel = '',
  hideSubLabelWhenCategorized = false,
  categorizeResults = false,
}) => {
  const componentElmId = elmId ? `${elmId}_` : ''
  return (
    <div
      data-elm-id={`${componentElmId}autosuggest_search_${index}_click`}
      className={cx('autosuggest-row')}
    >
      {!categorizeResults && (
        <div className={cx('autosuggest-icon-container')}>
          {!_.isEmpty(icon) && (
            <Icon
              name={icon.name}
              iconStyle='regular'
              color={icon.color || 'grayMedium'}
            />
          )}
        </div>
      )}
      <div
        data-elm-id={`${componentElmId}autosuggest_search_${index}_value`}
        className={cx('autosuggest-text')}
      >
        {label}
      </div>
      {categorizeResults && hideSubLabelWhenCategorized ? null : (
        <div className={cx('autosuggest-sublabel')}>{subLabel}</div>
      )}
    </div>
  )
}

Suggestion.propTypes = {
  elmId: PropTypes.string.isRequired,
  index: PropTypes.number,
  icon: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subLabel: PropTypes.string,
  hideSubLabelWhenCategorized: PropTypes.bool,
  categorizeResults: PropTypes.bool,
}
